import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function fetchPermissionList(listQuery) {
  const { data: raw } = await request.get('/system/permission', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
